<template>
  <v-app-bar class="custom-nav" clipped-left color="white" flat app>
    <!--  @click="turnIndex" -->
    <v-toolbar-title style="width: 20vh" class="logo-box">
      <img class="logo_img" :src="logo" />
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-tabs v-model="tab" fixed-tabs class="nav_tabs">
      <v-tab
        v-if="teacherLogin"
        :to="'/my-course'"
        :class="{
          'v-tab--active': isActive('my-course')
        }"
      >
        我的课程
      </v-tab>
      <v-tab
        v-if="teacherLogin"
        :to="'/my-prepare'"
        :class="{
          'v-tab--active': isActive('my-prepare')
        }"
      >
        我的备课
      </v-tab>
      <v-tab
        v-if="teacherLogin"
        :to="'/trial-class'"
        :class="{
          'v-tab--active': isActive('trial-class')
        }"
      >
        DEMO课
      </v-tab>
      <v-tab
        :to="'/my-resource'"
        :class="{
          'v-tab--active': isActive('my-resource')
        }"
      >
        网盘资料
      </v-tab>
      <!--      <v-tab
        :to="'/demo-class'"
        :class="{
          'v-tab&#45;&#45;active': isActive('demo-class')
        }"
      >
        DEMO课
      </v-tab>-->
    </v-tabs>
    <v-spacer></v-spacer>
    <Preload />
    <v-menu offset-y>
      <template #activator="{ on }">
        <button class="user_btn" v-on="on"></button>
      </template>
      <v-list>
        <v-list-item v-if="nameLogin" @click="turnPasswordReset">
          <v-list-item-title>
            <span class="body-2">修改密码</span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-title>
            <span class="body-2">退出登录</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>
import logoImg from '../../assets/img/common_logo.png'
import { getUserBasicInfo, SetLogout } from '@/libs/util'
import Preload from './preload.vue'
export default {
  name: 'Navbar',
  components: {
    Preload
  },
  data: () => ({
    logo: logoImg,
    tab: null,
    nameLogin: true,
    roles: [],
    teacherLogin: false
  }),
  created() {
    this.roles = getUserBasicInfo('roles')
    console.log('---roles--', this.roles)
    if (this.roles.includes('TEACHER')) {
      this.teacherLogin = true
    }
    console.log('--teacherLogin---', this.teacherLogin)
  },
  methods: {
    isActive(tab) {
      return this.$route.meta.tab === tab
    },
    turnIndex() {
      this.$router.push('/')
    },
    logout() {
      SetLogout()
    },
    turnPasswordReset() {
      this.$router.push('/passwordReset')
    }
  }
}
</script>
<style scoped lang="scss">
.logo-box {
  display: flex;
  flex: 0 0 150px;
}
.logo_img {
  width: 100%;
  vertical-align: middle;
}

.user_btn {
  width: 60px;
  height: 60px;
  background: url(../../assets/img/common_user.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80% auto;
  cursor: pointer;
}

.nav_tabs {
  background-color: transparent;
  max-width: 800px;
}
::v-deep .nav_tabs a {
  font-size: 16px !important;
  font-weight: bold;
}
.custom-nav {
  // 底部阴影
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1) !important;
}
</style>
